import React from 'react';
import c from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiEvent } from '@wix/da-bi/pkg/events';

import s from './SocialButtonBase.scss';

export interface Props {
  biData?: BiEvent;
  className?: string;
  labelClassName?: string;
  'aria-label'?: string;
  onClick: (e) => void;
}

const SocialButtonBase: React.FC<React.PropsWithChildren<Props>> = ({
  biData,
  className,
  labelClassName,
  onClick,
  children,
  'aria-label': ariaLabel,
}) => {
  return (
    <BiButton
      className={c(s['root'], s['updated-ui'], className)}
      biData={biData}
      onClick={onClick}
      type="button"
      aria-label={ariaLabel}
    >
      <div className={c(s['label'], labelClassName)}>{children}</div>
    </BiButton>
  );
};
SocialButtonBase.displayName = 'SocialButtonBase';

export default SocialButtonBase;
